var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrassrootsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 166,
    viewBox: "0 0 162 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 82,
    height: 86,
    rx: 8,
    fill: "#F0F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2373 55.2398C56.8092 56.5766 56 58.4625 56 60.4439V74.8385C56 78.8012 59.1894 82 63.1404 82H95.7005C97.2476 82 98.6757 80.878 98.8423 79.3264C99.0327 77.536 97.6284 76.0321 95.8909 76.0321H83.3715C82.705 76.0321 82.1814 75.5069 82.1814 74.8385C82.1814 74.1701 82.705 73.6449 83.3715 73.6449H100.461C102.008 73.6449 103.436 72.5229 103.603 70.9713C103.793 69.1809 102.389 67.677 100.651 67.677H83.3715C82.705 67.677 82.1814 67.1518 82.1814 66.4834C82.1814 65.815 82.705 65.2898 83.3715 65.2898H102.841C104.388 65.2898 105.816 64.1678 105.983 62.6162C106.173 60.8258 104.769 59.3219 103.031 59.3219H83.3715C82.705 59.3219 82.1814 58.7967 82.1814 58.1283C82.1814 57.4599 82.705 56.9347 83.3715 56.9347H98.0807C99.6277 56.9347 101.056 55.8127 101.222 54.2611C101.413 52.4707 100.009 50.9668 98.2711 50.9668H74.7078L78.2542 44.7363C78.4684 44.3543 78.5874 43.9485 78.5874 43.4711C78.5874 42.8504 78.3732 42.2775 77.9686 41.8001L76.9689 40.7258C76.0645 39.7948 74.565 39.7471 73.6129 40.6542L58.2373 55.2398Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 41.5,
    r: 5.5,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 162,
    height: 166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2775 0 0 0 0 0.225 0 0 0 0 0.6 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrassrootsLight);
export default __webpack_public_path__ + "static/media/GrassrootsLight.026ba093496cbc212d6c1e15fe76ac94.svg";
export { ForwardRef as ReactComponent };